const modules = import.meta.glob('./*.ts', { eager: true })
const lang: Record<string, any> = {}

for (const path in modules) {
  // 排除 index.ts 自身
  if (path.includes('index.ts')) continue
  
  // 获取文件名作为 key，例如 ./common.ts -> common
  const name = path.replace(/^\.\/(.*)\.\w+$/, '$1')
  lang[name] = (modules[path] as any).default
}

export default lang
